import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import { VAM2types } from "../../_loadingHelpers/VAMv2Types";
import { DOMhelpers, ToasterHelpers } from "../../../more/Helpers";
import EvService_ResourceLoadTable from './ResourceLoadTable';

interface RequestData {

    dateStart: Date,
    dateEnd: Date,
    evServices: Array<{ serviceID: string, amount: number }>;
    evServiceBookings: Array<{ serviceBookingID: string, amount: number }>;
}
//interface ResultData {
//    serviceID: string,

//    resourcesOK: boolean,
//    resourceBookings: Array<any>,
//    resources: Array<{
//        entity: VAM2types.PhysicalResource,
//        resourceID: string,
//        serviceResourceID: string,
//        occupationMax: number,
//        occupationCount: number,
//        occupationOK: boolean,
//        resourceMultiplier: number;
//        note: string;
//    }>
//}

class EvService_ResourceLoadCheck extends compose(_WidgetBaseSP) {
    templateString;

    private data: RequestData;
    private callback: (results: Array<VAM2types.ResourceLoadCheckResultData>) => any;
    private lastResult: Array<VAM2types.ResourceLoadCheckResultData>;

    private resourceTable: MdsLax<InstanceType<typeof EvService_ResourceLoadTable>>;

    // Construction-safe init (field initializer, not postCreate): this is a named-export
    // UTILITY widget instantiated via `new` (EvServiceBookingList) and never mdsWidget-wrapped,
    // so its create()/postCreate lifecycle never runs (mds runs create() only for the directly
    // wrapped class; dojo ran it on every `new`). _onGetCheckResults writes resultRegistry[id],
    // so it must exist on construction regardless of the render lifecycle. See _WidgetBaseSP ctor.
    private resultRegistry: Record<string, VAM2types.ResourceLoadCheckResultData> = {};

    loadForResou
    executeCheck(data: RequestData, resultCallback: (results: Array<VAM2types.ResourceLoadCheckResultData>) => any ) {
        this.data = data;
        this.callback = resultCallback;

        this.executeLoadCheck();
    }

    private executeLoadCheck() {

        let data = this.data;
        if (!data) return;

        this.RequestManager.callfunction("Webtool_API_EvService__GetResourceLoads",
            data,
            lang.hitch(this, this._onGetCheckResults),
            lang.hitch(this, this._onGetCheckError)
        );
    }

    //private applyResult(result: ResultData) {

    //    debugger;
    //    let fakeResourceBookings: Array<VAM2types.ResourceBooking> = [];
    //    for (let resultEntry of result.resources) {
    //        fakeResourceBookings.push({
    //            ID: resultEntry.resourceID + "-V",
    //            quantity_resource_max: resultEntry.occupationMax,
    //            quantity: resultEntry.occupationCount,
    //            quantity_max: resultEntry.occupationCount,
    //            quantity_pos_ev_serv: resultEntry.resourceMultiplier,
    //            ref_vt_resource: resultEntry.entity,
    //            ref_ht_service_resource: {
    //                quantity: resultEntry.resourceMultiplier,
    //                ID: resultEntry.serviceResourceID,
    //                Classname: "xxxxxx",
    //                note: resultEntry.note
    //            }

    //        });
    //    }

    //    if (!this.resourceTable) {
    //        this.resourceTable = new EvSB_ResourceLoadTable();

    //        this.resourceTable.placeAt(this.domNode);
    //    }

    //    this.resourceTable.setup(fakeResourceBookings)

    //}


    private _onGetCheckResults(results: Array<VAM2types.ResourceLoadCheckResultData>) {
        this.lastResult = results;

        //this.applyResult(result);

        for (let result of results) {
            this.resultRegistry[result.serviceID] = result;
        }

        if (this.callback) this.callback(results);
    }
    private _onGetCheckError(error: more.requestErrorMessage) {
        ToasterHelpers.showToast({
            title: "error checking resources",
            message: error.Message,
            iconClass: toasterIcons.error,
            timeout: 20000
        });

        if (this.callback) this.callback(null);

    }

    getResult(serviceBookingIDorServiceID: string): VAM2types.ResourceLoadCheckResultData {
        if (!this.resultRegistry) return;

        let reg = this.resultRegistry[serviceBookingIDorServiceID];
        if (!reg) {
            for (let key in reg) {
                let knownResult = this.resultRegistry[key];

                if (knownResult.serviceBookingID == serviceBookingIDorServiceID) return knownResult;
            }
        }

        return reg;
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.resultRegistry = {};
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}


export { EvService_ResourceLoadCheck, type RequestData as EvService_ResourceLoadCheckRequestData };
